/**
 * A palette colour as the current customer's theme defines it (the CSS custom
 * properties `_root-custom.scss` emits from `src/themes/<customer>`), for code
 * that has to hand a literal colour to a library — chart series, canvas — and
 * so can't use a class. `fallback` is the demo value, used if the variable is
 * missing (SSR, tests).
 */
export function themeColor(name: string, fallback: string): string {
  if (typeof document === "undefined") return fallback;
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
}
